import SquareIcon from './square-icon.png'

export const TitleIcons = {
    SquareIcon
}